import { ImageBackground, Pressable, StyleSheet } from 'react-native'
import React, { useCallback } from 'react'
import QRCode from 'react-native-qrcode-svg'
import { useRouter } from 'expo-router'

import { DS } from '../../design-system'
import QRPattern from '../../assets/QRPattern.png'
import { observer } from 'mobx-react-lite'
import { useStore } from '../../models'

interface QRLightBoxScreenProps {
  /** URL to encode in QR code. Falls back to store qrUrl if not provided */
  url?: string
  /** Override background color. Defaults to Brand/Purple */
  backgroundColor?: string
  /** Override description text */
  description?: string
}

export const QRLightBoxScreen = observer(({ url: urlProp, backgroundColor, description }: QRLightBoxScreenProps) => {
  const router = useRouter()
  const {
    game: { qrUrl: storeQrUrl }
  } = useStore()

  // Use prop URL if provided, otherwise fall back to store (for scheduled games)
  const qrUrl = urlProp || storeQrUrl

  const onGoBack = useCallback(() => {
    requestAnimationFrame(() => {
      setTimeout(() => {
        if (router.canGoBack()) {
          router.back()
          return
        }
        router.navigate('/(root)/(tabs)')
      }, 500)
    })
  }, [router])

  return (
    <DS.Frame style={[styles.container, backgroundColor && { backgroundColor }]}>
      <Pressable style={styles.backdrop} onPress={onGoBack} />
      <DS.Frame style={styles.handle} />

      <DS.Frame style={[styles.container, { paddingHorizontal: DS.spacing['24'] }, backgroundColor && { backgroundColor }]}>
        <DS.Frame flex={1} justifyContent="space-between" alignItems="center">
          <DS.Text variant="Body Medium/Regular" color="Global/White" textAlign="center" style={styles.title}>
            {description ?? 'Allow people near you to scan the code with their camera app to instantly join your game.'}
          </DS.Text>
          <ImageBackground source={QRPattern} style={styles.qrContainer}>
            <QRCode value={qrUrl} size={200} />
          </ImageBackground>
          <DS.Button variant="Large/Secondary" type="On Light" onPress={onGoBack}>
            Done
          </DS.Button>
        </DS.Frame>
      </DS.Frame>
    </DS.Frame>
  )
})

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: DS.palette['Brand/Purple'],
    paddingBottom: DS.spacing['12']
  },
  handle: {
    width: 36,
    height: 4,
    borderRadius: 4,
    backgroundColor: `${DS.palette['Global/White']}80`,
    alignSelf: 'center',
    marginTop: DS.spacing['24'],
    marginBottom: DS.spacing['32']
  },
  title: {
    fontSize: 16
  },
  qrContainer: {
    width: 340,
    height: 340,
    borderRadius: 170,
    alignItems: 'center',
    justifyContent: 'center'
  },
  backdrop: {
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    zIndex: 1000
  }
})
